import Button from '@atlaskit/button';
import SectionMessage from '@atlaskit/section-message';
import React from 'react';
export const GenericError = props => {
  const getErrorConfig = () => {
    if (props.type === 'loading') {
      return {
        title: 'Loading error',
        message: 'We ran into a little trouble and could not load the details. Please try again.',
        action: /*#__PURE__*/React.createElement(Button, {
          appearance: "link",
          spacing: "none",
          onClick: props.onTryAgainClick
        }, "Try again")
      };
    } else {
      return {
        title: 'Connection error',
        message: 'Oops! Looks like something went wrong. Please check your internet connection and try again'
      };
    }
  };
  const errorConfig = getErrorConfig();
  return /*#__PURE__*/React.createElement(SectionMessage, {
    title: errorConfig.title,
    appearance: "error"
  }, /*#__PURE__*/React.createElement("p", null, errorConfig.message), errorConfig.action);
};